// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1cC8p","additionalInfo":"AgreementModal_additionalInfo__3h6Gp"};